import { Injectable } from "@angular/core";
import { IGenericApiResponse } from "../../models/common/GenericApiResponse";
import { IdampHttpClient } from "../common/IdampHttpClient";
import { IGraphPermissionTierReview, ISubmitGraphPermissionTierReviewBulkRequest } from "src/app/models/graph/applications/GraphPermissionTierReview";

@Injectable({ providedIn: 'root' })
export class GraphPermissionTierReviewService {
    constructor(private http: IdampHttpClient) { }

    public async GetAllReviews(): Promise<IGenericApiResponse<IGraphPermissionTierReview[]>> {
        const path = `identity/graph-permission-tiers`;
        return await this.http.GetAsync<IGenericApiResponse<IGraphPermissionTierReview[]>>(path);
    }

    // Single-row saves are just a bulk update of one \u2014 same endpoint, no separate single-item API.
    public async SubmitReview(request: ISubmitGraphPermissionTierReviewBulkRequest): Promise<IGenericApiResponse<string>> {
        const path = `identity/graph-permission-tiers`;
        return await this.http.PatchAsync<ISubmitGraphPermissionTierReviewBulkRequest, IGenericApiResponse<string>>(path, request);
    }
}
